import { PlayerColor } from "./Player";

export class Checker {
  constructor(public color: PlayerColor) {}
}
